export const digitalKycDimensions = {
	videoHeight: "332px",
	videoWidth: "248px",
};

export const mimeType = "video/mp4";

export const mediaRecorderErrorMessage =
	"The MediaRecorder API is not supported in your browser.";

export const geoLocationErrorMessage = "Geolocation not supported";

export const NAVIGATOR_STATE = {
	GRANTED: "granted",
};

export const FACEMESH_CDN_PATH =
	"https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh";
